module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-1-87e1b12a8eeef2c15d231be1669e7b39.jpg";